'use client';

import type { PropsWithChildren } from 'react';
import { useIsDialogOpen } from '../ImageGalleryProvider/ImageGalleryProvider.client';

/**
 * ImageGalleryImageWrapper is a wrapper component that exists as a client component
 * to wrap the image and handle the click event for opening the image gallery dialog.
 * You can pass a server component as a child to this wrapper.
 */
export const ImageGalleryImageWrapper = ({ children }: PropsWithChildren) => {
  const [, setIsDialogOpen] = useIsDialogOpen();

  return (
    <button className="cursor-pointer" onClick={() => setIsDialogOpen(true)} type="button">
      {children}
    </button>
  );
};
